<template>
  <div class="asc-file-upload-file-list--container">
    <asc-file-upload-file
      v-for="item in items"
      :key="`${item.displayName}-${item.id}`"
      :file="item"
      :show-file-visibility-toggle="showFileVisibilityToggle"
      :allow-file-remove="allowFileRemove"
      :on-remove-file="onRemoveFile"
      :show-file-remove-notification="showFileRemoveNotification"
      :remove-file-notification-count-down="removeFileNotificationCountDown"
      :allow-file-download="allowFileDownload"
      :on-download-file="onDownloadFile"
      :disabled="disabled"
      :viewable="viewable"
      :can-edit-attachment-captions="canEditAttachmentCaptions"
      :handle-update-attachment-caption="handleUpdateAttachmentCaption"
      @toggleFileVisibility="handleToggleFileVisibility"
    ></asc-file-upload-file>
  </div>
</template>

<script>
import AscFileUploadFile from './AscFileUploadFile'

export default {
  name: 'AscFileUploadFileList',

  components: {
    AscFileUploadFile,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    showFileVisibilityToggle: {
      type: Boolean,
      default: false,
    },
    allowFileRemove: {
      type: Boolean,
      default: true,
    },
    onRemoveFile: {
      type: Function,
      default: () => {},
    },
    showFileRemoveNotification: {
      type: Boolean,
      required: true,
    },
    removeFileNotificationCountDown: {
      type: Number,
      required: true,
    },
    allowFileDownload: {
      type: Boolean,
      default: true,
    },
    onDownloadFile: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    viewable: {
      type: Boolean,
      default: false,
    },
    canEditAttachmentCaptions: {
      type: Boolean,
      default: false,
    },
    handleUpdateAttachmentCaption: {
      type: Function,
      default: () => {},
    },
  },

  methods: {
    handleToggleFileVisibility(fileInfo) {
      this.$emit('toggleFileVisibility', fileInfo)
    },
  },
}
</script>

<style lang="scss">
.asc-file-upload-file-list--container {
  margin-top: 8px;
  min-width: 260px;
}
</style>
